import React from 'react';
import {
  CallbackResult,
  RedirectBasedPayment,
} from '../common/GenericPayment/RedirectBasedPayment';

interface GenericFormProps {
  loading?: boolean;
  onPay: () => Promise<CallbackResult>;
  totalDue?: number | string;
  error?: string;
  launchWindow?: boolean;
}

export const GenericForm = ({
  loading,
  onPay,
  launchWindow,
  totalDue,
  error,
}: GenericFormProps) => {
  return (
    <RedirectBasedPayment
      totalDue={totalDue}
      launchWindow={launchWindow}
      onClickCallback={onPay}
      loading={loading}
      error={error}
      dataTestId="generic-form-component"
    >
      The button below will take you to our third-party payment system to make
      your payment.
    </RedirectBasedPayment>
  );
};
